module.exports = __webpack_public_path__ + "static/media/Logo_Dial_Blanc.b507f1b8.png";